import React from 'react'
import { Link } from 'react-router-dom'

function CreatedMessageStepper({id}) {
  return (
    <div className='px-10'>
        <div className=''>
            <div className='text-green-700 text-lg mb-6 font-bold'>Congratulations on creating your case !</div>
            Attorneys will begin reviewing your case and may send requests to view more details of your case. We recommend that you add as much detail as possible.
            </div>
        {/* <Link to= {"/caseDetailsAdditional/"+id}>
            <div className='rounded mt-4 px-4 p-1  w-full flex bg-green-600 text-white w-max cursor-pointer shadow-xl'> Add more details now</div>

        </Link> */}
    </div>
  )
}

export default CreatedMessageStepper